import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";

export type HomePageRoutingParams = {
    readonly subscriptionCancelType?: "signalsDigest";
    readonly openImpactReport?: string;
};

export const homePageParams: StateParamsDeclaration<HomePageRoutingParams> = {
    // The URL's `{subscriptionCancelType:signalsDigest}` already types this param; re-declaring a `type`
    // here gives UIRouter two type configurations for it and crashes state registration.
    subscriptionCancelType: { dynamic: true },
    openImpactReport: { dynamic: true },
};
